import React, { useState } from "react";
import axios from "axios";
import { toast } from "@/components/ui/sonner";
import { Loader2, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

const API = process.env.REACT_APP_BACKEND_URL;

export const Batch1ShowcaseCard = ({ headers, onDone }) => {
  const [pv, setPv] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async (dry) => {
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/api/admin/demo-manager/school/batch1-showcase?dry_run=${dry}`, {}, { headers });
      if (dry) setPv(data);
      else {
        toast.success(`Removed ${data.test_periods_to_remove.length} test periods and ${data.users_removed || 0} test users${data.showcase_created ? " · Q2 2027 showcase ready" : ""}`);
        setPv(null); onDone?.();
      }
    } catch (e) { toast.error(e?.response?.data?.detail || "Showcase setup failed"); } finally { setBusy(false); }
  };
  return (
    <div className="mt-6 rounded-xl border border-[#e5e7eb] bg-white p-5" data-testid="batch1-showcase-card">
      <div className="flex items-center gap-2"><Sparkles className="h-4 w-4 text-[#007a9e]" /><h2 className="text-base font-bold text-[#111827]">Scoring v1.1 showcase</h2></div>
      <p className="mt-1 text-[13px] text-[#4b5563]">Removes leftover TEST periods and test users from the showcase schools (archived first) and gives Riverbend an in-progress <b>Q2 2027</b> diagnostic on v1.1, so you can open it and jump straight to the three corrected questions.</p>
      {pv && (
        <div className="mt-3 rounded-lg border border-[#eef0f2] bg-[#f9fafb] p-3 text-[13px]" data-testid="batch1-showcase-preview">
          <div><b>{pv.test_periods_to_remove.length}</b> TEST periods will be removed{pv.test_periods_to_remove.length ? `: ${[...new Set(pv.test_periods_to_remove.map((t) => t.period_label))].join(", ")}` : ""}.</div>
          <div className="mt-1"><b>{(pv.test_users_to_remove || []).length}</b> test users will be removed{(pv.test_users_to_remove || []).length ? `: ${pv.test_users_to_remove.map((u) => u.full_name || u.email).join(", ")}` : ""}.</div>
          <div className="mt-1">{pv.showcase_existing ? "Riverbend already has the v1.1 showcase period." : pv.showcase_source ? `Riverbend gets "Q2 2027" (v1.1), copied from ${pv.showcase_source.period_label}.` : "No finished Riverbend period to copy from."}</div>
        </div>
      )}
      <div className="mt-3 flex flex-wrap gap-2">
        <Button size="sm" variant="outline" disabled={busy} onClick={() => run(true)} data-testid="batch1-showcase-preview-btn">{busy && !pv ? <Loader2 className="h-3.5 w-3.5 mr-1 animate-spin" /> : null}Preview</Button>
        {pv && <Button size="sm" className="bg-[#007a9e] hover:bg-[#00607d] text-white" disabled={busy} onClick={() => run(false)} data-testid="batch1-showcase-apply-btn">Apply</Button>}
      </div>
    </div>
  );
};
